export const FETCH_PARTS_REQUEST = 'FETCH_PARTS_REQUEST';
export const FETCH_PARTS_SUCCESS = 'FETCH_PARTS_SUCCESS';
export const FETCH_PARTS_FAILURE = 'FETCH_PARTS_FAILURE';

